import { render, staticRenderFns } from "./MovimentacaoDetalheCabecalhoBaixa.vue?vue&type=template&id=3ab3e7d6&scoped=true&"
import script from "./MovimentacaoDetalheCabecalhoBaixa.vue?vue&type=script&lang=js&"
export * from "./MovimentacaoDetalheCabecalhoBaixa.vue?vue&type=script&lang=js&"
import style0 from "./MovimentacaoDetalheCabecalhoBaixa.vue?vue&type=style&index=0&id=3ab3e7d6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab3e7d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
